(function () {
  'use strict';
  if (window.BiossSampleRequest) return;
  var node = document.querySelector('[data-bioss-sample-config]');
  if (!node) return;
  var config; try { config = JSON.parse(node.textContent); } catch (_) { return; }
  var root = config.root || '/', campaign = 'bioss-recombinant-sample-v2';
  var keys = ['Free sample SKU','Free sample variant ID','Free sample qualifying SKU','Free sample qualifying product ID','Free sample quantity','Free sample campaign','Free sample request ID','Free sample requested at','Free sample status','Free sample discount code'];
  var mapPromise, activeOffer, pending = false, checking = false, checkoutPending = false;
  async function get(url, options) {
    var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, 10000);
    try {
      var r = await fetch(url, Object.assign({credentials:'same-origin',cache:'no-store',signal:controller.signal}, options || {}));
      if (!r.ok) throw new Error('request');
      return await r.json();
    } finally { clearTimeout(timer); }
  }
  function post(route, data) { return get(root + route, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data)}); }
  function cart() { return get(root + 'cart.js'); }
  function mapping() {
    if (!mapPromise) mapPromise = get(config.mapping).catch(function (e) { mapPromise = null; throw e; });
    return mapPromise;
  }
  function empty() { var a = {}; keys.forEach(function (key) { a[key] = ''; }); return a; }
  function lines(c) { return c.items.filter(function (i) { return i.properties && i.properties._bioss_sample_campaign === campaign; }); }
  function paid(c) { return c.items.some(function (i) { return !(i.properties && i.properties._bioss_sample_campaign === campaign) && i.quantity > 0 && i.final_line_price > 0; }); }
  function source(c, id) { return c.items.find(function (i) { return i.product_id === id && i.quantity > 0; }); }
  function approvedPresent(c, data) {
    var approved = new Set(Object.keys(data).flatMap(function (key) { return data[key][2].map(function (v) { return v[1]; }); }));
    return c.items.some(function (i) { return approved.has(i.variant_id); });
  }
  function unchangedPaidPrices(before, after) {
    return before.items.every(function (i) {
      var next = after.items.find(function (v) { return v.variant_id === i.variant_id && JSON.stringify(v.properties || {}) === JSON.stringify(i.properties || {}); });
      return next && next.quantity === i.quantity && next.final_line_price <= i.final_line_price;
    }) && (!Number.isFinite(before.total_price) || !Number.isFinite(after.total_price) || after.total_price <= before.total_price);
  }
  function codes(c) {
    var result = (c.discount_codes || []).map(function (d) { return d.code; });
    c.items.forEach(function (i) { (i.line_level_discount_allocations || []).forEach(function (a) { var d = a.discount_application; if (d && d.type === 'discount_code') result.push(d.title); }); });
    (c.cart_level_discount_applications || []).forEach(function (d) { if (d.type === 'discount_code') result.push(d.title); });
    return result.filter(function (s, i, all) { return typeof s === 'string' && s && all.findIndex(function (v) { return String(v).toUpperCase() === s.toUpperCase(); }) === i; });
  }
  function free(i) { return i && i.quantity === 1 && i.final_line_price === 0; }
  function render(c, message) {
    var sample = lines(c)[0], a = c.attributes || {};
    var checkoutCodes = codes(c).join(',');
    document.querySelectorAll('[data-bioss-cart-discount-codes]').forEach(function (input) {
      input.value = checkoutCodes;
      input.disabled = !checkoutCodes;
      input.dataset.biossSampleCheckout = String(!!sample);
    });
    document.querySelectorAll('[data-sample-request-summary]').forEach(function (el) {
      el.hidden = !sample && !message;
      el.querySelector('h2').textContent = sample ? config.labels.summary : config.labels.removed;
      el.querySelector('[data-request-sku]').textContent = sample ? sample.sku : '';
      el.querySelector('[data-request-primary]').textContent = sample ? (sample.properties._bioss_sample_source_sku || a[keys[2]] || '') : '';
      el.querySelectorAll('[data-request-details]').forEach(function (p) { p.hidden = !sample; });
      el.querySelector('[data-request-remove]').hidden = !sample;
      el.querySelector('[data-request-status]').textContent = message || (sample && (!free(sample) || !paid(c)) ? config.labels.review_error : '');
    });
  }
  async function removeOwned(requestId) {
    var c = await cart();
    for (var item of lines(c).filter(function (i) { return !requestId || i.properties._bioss_sample_request_id === requestId; })) {
      await post('cart/change.js', {id:item.key,quantity:0});
      c = await cart();
    }
    if (lines(c).some(function (i) { return !requestId || i.properties._bioss_sample_request_id === requestId; })) throw new Error('remove');
    if (!lines(c).length) {
      var remaining = codes(c).filter(function (s) { return s.toUpperCase() !== config.discount_code.toUpperCase(); });
      await post('cart/update.js', {attributes:empty(),discount:remaining.join(',')});
    }
    return cart();
  }
  function lock(fn) { return navigator.locks ? navigator.locks.request('bioss-sample-discount', fn) : fn(); }
  async function reconcile() {
    if (checking || pending) return;
    checking = true;
    try {
      await lock(async function () {
        if (pending) return;
        var c = await cart();
        if (!lines(c).length && c.attributes && c.attributes[keys[0]]) {
          await post('cart/update.js',{attributes:empty()}); c = await cart();
        }
        render(c);
      });
    } catch (_) {} finally { checking = false; }
  }
  async function choices(entry) {
    var result = await Promise.all(entry[2].map(async function (candidate) {
      try {
        var p = await get(root + 'products/' + candidate[0] + '.js');
        var v = p.variants.find(function (v) { return v.id === candidate[1] && v.sku === candidate[2] && v.available === true && /-20ul$/i.test(v.sku); });
        if (!v) return null;
        var img = p.featured_image || p.images[0] || ''; if (img.indexOf('//') === 0) img = 'https:' + img;
        return {product_id:p.id,variant_id:v.id,handle:p.handle,sku:v.sku,volume_ul:20,available:true,title:p.title,url:root+'products/'+p.handle,image:img};
      } catch (_) { return null; }
    }));
    return result.filter(Boolean);
  }
  async function getOffer(input) {
    if (!config.enabled || !config.eligible_customer || !config.discount_code) return {eligible:false};
    var item = input.item, data = await mapping(), entry = data[String(item.product_id)];
    if (!entry) return {eligible:false};
    var c = await cart();
    var needsPrimary = !source(c,item.product_id) || !paid(c);
    if ((needsPrimary && input.page_entry !== true) || lines(c).length || approvedPresent(c,data)) return {eligible:false};
    var available = (await choices(entry)).filter(function (v) { return !c.items.some(function (i) { return i.variant_id === v.variant_id; }); });
    if (!available.length) return {eligible:false};
    activeOffer = {eligible:true,limit:1,offer_id:crypto.randomUUID(),source_product_id:item.product_id,target:entry[1],choices:available,primary_required:needsPrimary};
    return activeOffer;
  }
  async function save(input) {
    if (pending) throw new Error('busy');
    pending = true;
    var attempted = false;
    try {
      if (!config.enabled || !config.eligible_customer || !activeOffer || input.offer_id !== activeOffer.offer_id || input.source_product_id !== activeOffer.source_product_id || input.quantity !== 1) throw new Error('offer');
      var data = await mapping(), available = await choices(data[String(input.source_product_id)]);
      var chosen = available.find(function (v) { return v.variant_id === input.variant_id; });
      if (!chosen) throw new Error('unavailable');
      var c = await cart(), primary = source(c,input.source_product_id), existing = lines(c);
      if (!primary || !primary.sku || !paid(c)) throw new Error('primary');
      if (existing.length) {
        if (existing.length !== 1 || existing[0].variant_id !== input.variant_id || !free(existing[0])) throw new Error('existing');
        return {sample_added:true,variant_id:input.variant_id,quantity:1,cart:c};
      }
      if (approvedPresent(c,data)) throw new Error('existing');
      var before = c;
      var properties = {_bioss_sample_campaign:campaign,_bioss_sample_request_id:input.request_id,_bioss_sample_source_sku:primary.sku,_bioss_sample_source_product_id:String(primary.product_id)};
      attempted = true;
      await post('cart/add.js',{items:[{id:chosen.variant_id,quantity:1,properties:properties}]});
      c = await cart();
      var combined = codes(c);
      if (!combined.some(function (s) { return s.toUpperCase() === config.discount_code.toUpperCase(); })) combined.push(config.discount_code);
      await post('cart/update.js',{discount:combined.join(',')});
      c = await cart();
      var added = lines(c).find(function (i) { return i.properties._bioss_sample_request_id === input.request_id; });
      if (!free(added) || added.variant_id !== chosen.variant_id || !paid(c) || !unchangedPaidPrices(before,c)) throw new Error('discount');
      var values = [chosen.sku,String(chosen.variant_id),primary.sku,String(primary.product_id),'1',campaign,input.request_id,new Date().toISOString(),'Added - discount verified',config.discount_code];
      var attributes = {}; keys.forEach(function (key, i) { attributes[key] = values[i]; });
      await post('cart/update.js',{attributes:attributes});
      c = await cart();
      if (keys.some(function (key) { return c.attributes[key] !== attributes[key]; }) || !free(lines(c).find(function (i) { return i.properties._bioss_sample_request_id === input.request_id; }))) throw new Error('verify');
      render(c);
      document.dispatchEvent(new CustomEvent('bioss:sample-added',{detail:{campaign:campaign,request_id:input.request_id,variant_id:chosen.variant_id,sku:chosen.sku}}));
      return {sample_added:true,variant_id:chosen.variant_id,quantity:1,cart:c};
    } catch (error) {
      if (attempted) {
        try { var restored = await removeOwned(input.request_id); render(restored); return {sample_added:false,rolled_back:true,cart:restored}; }
        catch (_) { throw new Error('uncertain'); }
      }
      throw error;
    } finally { pending = false; }
  }
  function claim(input) { return lock(function () { return save(input); }); }
  async function checkout(form) {
    var c = await cart(), data = new FormData(form), updates = {};
    form.querySelectorAll('[data-bioss-cart-line-key]').forEach(function (input) {
      var key = input.dataset.biossCartLineKey, value = input.value.trim();
      if (!/^\d+$/.test(value) || !Number.isSafeInteger(Number(value)) || !c.items.some(function (item) { return item.key === key; })) throw new Error('quantity');
      updates[key] = Number(value);
    });
    var payload = {updates:updates}, attributes = {};
    if (data.has('note')) payload.note = data.get('note');
    data.forEach(function (value, key) {
      var match = /^attributes\[([^\]]+)\]$/.exec(key);
      if (match && typeof value === 'string') attributes[match[1]] = value;
    });
    if (Object.keys(attributes).length) payload.attributes = attributes;
    await post('cart/update.js',payload);
    c = await cart();
    var samples = lines(c), activeCodes = codes(c);
    if (samples.length && (!config.eligible_customer || samples.length !== 1 || !free(samples[0]) || !paid(c) || !activeCodes.some(function (s) { return s.toUpperCase() === config.discount_code.toUpperCase(); }))) throw new Error('discount');
    var destination = root + 'checkout';
    activeCodes.slice().reverse().forEach(function (code) {
      destination = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(destination);
    });
    location.assign(destination);
  }
  document.addEventListener('submit',async function (event) {
    var form = event.target, button = event.submitter;
    if (event.defaultPrevented || !form.matches('.bioss-cart-form') || !button || button.name !== 'checkout') return;
    var field = form.querySelector('[data-bioss-cart-discount-codes]');
    if (!field || field.dataset.biossSampleCheckout !== 'true') return;
    event.preventDefault();
    if (checkoutPending || pending) return;
    if (window.BiossPurchaseOrder && !window.BiossPurchaseOrder.ready()) return;
    checkoutPending = true;
    form.inert = true;
    try { await lock(function () { return checkout(form); }); }
    catch (_) {
      try { render(await cart(),config.labels.review_error); } catch (_) {
        var status = form.querySelector('[data-request-status]');
        if (status) status.textContent = config.labels.review_error;
      }
      form.inert = false;
      checkoutPending = false;
      var summary = form.querySelector('[data-sample-request-summary]');
      if (summary) { summary.hidden = false; summary.scrollIntoView({block:'center'}); }
    }
  });
  window.addEventListener('pageshow',function () {
    if (checkoutPending) {
      checkoutPending = false;
      document.querySelectorAll('.bioss-cart-form').forEach(function (form) { form.inert = false; });
    }
  });
  document.addEventListener('click',async function (event) {
    var button = event.target.closest('[data-request-remove]'); if (!button || pending) return;
    button.disabled = true;
    try { await lock(async function () { var c = await removeOwned(); render(c); }); location.reload(); }
    catch (_) { button.closest('[data-sample-request-summary]').querySelector('[data-request-status]').textContent = config.labels.remove_error; button.disabled = false; }
  });
  window.BiossSampleRequest = {ready:true,getOffer:getOffer,claim:claim,reconcile:reconcile};
  document.addEventListener('cart:refresh',reconcile);
  window.addEventListener('pageshow',reconcile);
  window.addEventListener('focus',reconcile);
  if (document.querySelector('[data-sample-request-summary]')) reconcile();
})();
